import {combineReducers} from 'redux'
import Immutable from 'seamless-immutable'
import {get} from 'lodash'
import types from 'actions/types'

export const statusTypes = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.statusTypes', state)
    default:
      return state
  }
}

export const companies = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.companies', state)
    default:
      return state
  }
}

export const userTypes = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.userTypes', state)
    default:
      return state
  }
}

export const contacts = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.contacts', state)
    default:
      return state
  }
}

export const dateTypes = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.dateTypes', state)
    default:
      return state
  }
}

export const timeKey = (state = Immutable('custom:'), action) => {
  switch (action.type) {
    case types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

export const jobTypes = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.jobTypes', state)
    default:
      return state
  }
}

export default combineReducers({
  statusTypes,
  companies,
  userTypes,
  contacts,
  timeKey,
  dateTypes,
  targetStart,
  targetEnd,
  jobTypes,
})
